{
  "title": "Resistance",
  "source": "Player's Handbook",
  "levelAndSchool": "Abjuration cantrip",
  "level": 0,
  "castingTime": "1 action",
  "range": "Touch",
  "components": "V, S, M (a miniature cloak)",
  "duration": "Concentration, up to 1 minute",
  "description": [
    "You touch one willing creature. Once before the spell ends, the target can roll a d4 and add the number rolled to one saving throw of its choice. It can roll the die before or after the saving throw. The spell then ends."
  ],
  "spellLists": ["artificer", "cleric", "druid"]
}
